import Inter_Medium_woff2_namespaceObject from "../../static/font/Inter-Medium.woff2";
export default Inter_Medium_woff2_namespaceObject;
